export const P = 'P';
export const C = 'C';
export const RBAC = 'RBAC';
export const OIDC = 'OIDC';

export const PROJECTCARDACTIONS = false;
export const PROJECTFILTERING = false;
